export const returnPolicyData = [
  {
    title: "Returns",
    points: [
      "You have 30 days from the date of receipt to request a return.",
      "To be eligible for a return, your item must be unused and in the same condition that you received it. The item must be in its original packaging.",
      "Some items, such as personalized items, clearance items, etc., are non-returnable.",
      "To initiate a return, please contact us at support@example.com or use the return portal on our website.",
    ],
  },
  {
    title: "Refunds",
    points: [
      "Once we receive your item, we will inspect it and notify you of the status of your refund.",
      "If approved, your refund will be issued to your original method of payment.",
      "Refunds may take 5–7 business days to appear in your account.",
    ],
  },
  {
    title: "Exchanges",
    points: [
      "If your item is defective or damaged, we will exchange it for the same item. Notify us within 7 days of delivery.",
      "If you want to exchange for a different size or variant, the item must be returned in its original condition.",
    ],
  },
  {
    title: "Shipping Costs",
    points: [
      "You are responsible for paying your own shipping costs for returning the item. Shipping costs are non-refundable.",
      "If the return is due to our error (e.g. incorrect or defective item), we will cover return shipping costs.",
    ],
  },
  {
    title: "How to Start a Return or Exchange",
    points: [
      "Visit our Returns & Exchanges page to request a return label.",
      "Once approved, you will receive instructions on how and where to send your package.",
    ],
  },
];
